<template>
  <div>
    <xm-overlay :show="show"
                :click="overlayClick"></xm-overlay>
    <transition name="xm-modal">
      <div class="xm-modal"
           v-if="show">
        <div class="xm-modal-inner">
          <div class="xm-modal-title">
            <slot name="title">Confirm</slot>
          </div>
          <div class="xm-modal-text">
            <slot name="content"></slot>
          </div>
        </div>
        <slot name="buttons">
        </slot>
         <slot>
        </slot>
      </div>
    </transition>
  </div>
</template>


<script>
import Overlay from './Overlay';

export default {
  name: 'xm-modal',
  components: {
    Overlay
  },
  props: {
    show: { // init status
      type: Boolean,
      default: false
    },
    overlayClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    open() {
      this.$emit('open', this);
    },
    close() {
      this.$emit('close', this);
    },
    overlayClick() {
    }
  }
};
</script>

<style lang="less" scope>
@import '../core/variables.less';
@import '../core/mixins.less';

@modalBgColor: #e8e8e8;
@modalButonColor : @color-primary;
@modalButonBg: @modalBgColor;
@modalButonActiveBg: #d4d4d4;
@modalDuration: 300ms;


.xm-modal {
  width: 70%;
  position: fixed;
  z-index: 11000;
  margin-top: 0;
  top: 50%;
  left: 15%;
  text-align: center;
  border-radius: 0.2rem;
  opacity: 1;
  transform: translate3d(0, -50%, 0) scale(1);
  transition-property: transform, opacity;
  transition-duration: @modalDuration;
  color: @color-text;
  // -moz-box-shadow:0px 0px 10px #333333; -webkit-box-shadow:0px 0px 10px #333333; 
  // box-shadow:0px 0px 10px #333333;

  &.xm-modal-enter,
  &.xm-modal-leave-active {
    opacity: 0;
    z-index: 11000-1;
    transform: translate3d(0, -50%, 0) scale(0.815);
  }
}

.xm-modal-inner {
  padding: 0.3rem;
  border-radius: 0.2rem 0.2rem 0 0;
  // border: 0.01rem solid #e8e8e8;
  position: relative;
  background: #fff;
  border:none;
}

.xm-modal-title {
  font-weight: 500;
  font-size: 0.9rem;
  text-align: center;
  +.xm-modal-text {
    margin-top: 0.25rem;
    max-height: 3rem;
    overflow: scroll;
  }
}

.xm-modal-buttons {
  height: 1rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  &.modal-buttons-vertical {
    display: block;
    height: auto;
  }
}

.xm-modal-button {
  width: 100%;
  padding: 0 0.2rem;
  height: 1rem;
  font-size: 0.34rem;
  line-height: 1rem;
  text-align: center;
  color: @color-primary;
  background: #fff;
  display: block;
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  .hairline(right, #b5b5b5);
  -webkit-box-flex: 1;
  -ms-flex: 1;
  border:none;
  border-right: 0.02rem solid #e8e8e8;
  border-top: 0.01rem solid #e8e8e8;
  &:first-child {
    border-radius: 0 0 0 0.2rem;
  }
  &:last-child {
    .hairline-remove(right);
    border-radius: 0 0 0.2rem 0;
    border-right: none;
  }
  &:first-child:last-child {
    border-radius: 0 0 0.2rem 0.2rem;
  }
  &.xm-modal-button-bold {
    font-weight: 500;
  }
  &.xm-modal-button-cancel {
    color: @color-text-secondary;
  }
  &.xm-modal-button-disabled {
    color: @color-text-gray;
    &:active {
      background: @modalBgColor;
    }
  }
  &:not(.modal-button-disabled):active {
    background: @modalButonActiveBg;
  }
  .xm-modal-buttons-vertical & {
    .hairline-remove(right);
    .hairline-remove(top);
    .hairline(bottom, #b5b5b5);
    border-radius: 0;
    &:last-child {
      border-radius: 0 0 0.2rem 0.2rem;
      .hairline-remove(bottom);
    }
  }
}

.xm-modal-no-buttons {
  .xm-modal-inner {
    border-radius: 0.2rem;
    .hairline-remove(bottom);
  }
  .xm-modal-buttons {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue